import { createSelector } from 'reselect';

const getState = state => state.events.data;

const getIds = (_, ids) => ids;

const getCollection = createSelector(getState, state => state.byId);

export const getByIds = createSelector(
  getCollection,
  getIds,
  (collection, ids) => ids?.map(id => collection?.[id]) ?? []
);
